<script setup>
import {useField, useForm} from "vee-validate";
import {useI18n} from "vue-i18n";
import {useAppStore} from "@/stores/app.js";
import {useRoute, useRouter} from "vue-router";
import InputShowPassword from "@/components/inputs/InputShowPassword.vue";
import {USER_FIELDS} from "@/utilities/enums.js";
import {useUserStore} from "@/stores/user.js";
import {URLS_FACTORY} from "@/router/urls.js";
import {EndpointsFactory} from "@/utilities/endpoints.js";
import {WorkerResponseCode} from "@/utilities/workerUtilites.js";
import {ref} from "vue";
import {useRules} from "vuetify/labs/rules/";

const {t: $t} = useI18n();
const pageLabelPrefix = 'login.';

const {handleSubmit} = useForm({
  keepValuesOnUnmount: true
});

const emailMaxLength = Number(import.meta.env.VITE_MAIL_MAX_LENGTH);
const emailMinLength = Number(import.meta.env.VITE_MAIL_MIN_LENGTH);
const passwordMaxLength = Number(import.meta.env.VITE_PASSWORD_MAX_LENGTH);
const rules = useRules();
const emailRules = [rules.required(), rules.email(), rules.maxLength(emailMaxLength), rules.minLength(emailMinLength)];
const passwordRules = [rules.required(), rules.maxLength(passwordMaxLength)];
const loginData = {
  email: useField(USER_FIELDS.email, emailRules),
  password: useField(USER_FIELDS.password, passwordRules)
};

const appStore = useAppStore();
const $router = useRouter();
const $route = useRoute();
const userStore = useUserStore();
const validForm = ref(false);

const submit = handleSubmit(values => {
  if(!validForm.value){
    return;
  }
  appStore.showSpinner();

  EndpointsFactory.execApiViaWorker({
      url: EndpointsFactory.getEndpoint(EndpointsFactory.ENDPOINTS.LOGIN),
      method: 'POST',
      body: JSON.stringify(values)
    },
    WorkerResponseCode.LOGIN, ({result}) => {
      userStore.setUser(result.user);
      userStore.setNotificationToken(null); //resetto il token notifiche per sicurezza
      if($route.query.redirect){
        $router.push($route.query.redirect);
      }
      else{
        $router.push(URLS_FACTORY.getURL(URLS_FACTORY.URLS_FULL_PATHS.FULL_DASHBOARD));
      }
      appStore.hideSpinner();
    }, ({http_code, result}) => {
      if(http_code === 401){
        appStore.showError({body: $t(pageLabelPrefix + 'invalid_credentials')});
        return;
      }
      console.warn(result); //TODO togliere
      appStore.showError();
    }, true);
});
</script>

<template>
  <div class="wrapper-l">

    <v-card class="gen-card card-shadow card-log">
      <v-card-text>
        <div class="main-log">
          <h3 class="title-log">{{ $t(pageLabelPrefix + "login_title") }}</h3>

          <v-form v-model="validForm" class="form-reg" @submit.prevent="submit">
            <div>
              <v-label class="inpt-label">{{ $t(pageLabelPrefix + 'email') }}</v-label>
              <v-text-field v-model.trim="loginData.email.value.value"
                            :error-messages="loginData.email.errorMessage.value"
                            class="inpt-gen" inputmode="email" type="email" :rules="emailRules"
                            required></v-text-field>

              <v-label class="inpt-label">{{ $t(pageLabelPrefix + 'password') }}</v-label>
              <input-show-password v-model.trim="loginData.password.value.value"
                                   :error-messages="loginData.password.errorMessage.value"
                                   :rules="passwordRules" class="inpt-gen"></input-show-password>
            </div>
            <div class="btn-wrapper">
              <v-btn class="m-btn btn-log" size="large" type="submit">
                {{ $t(pageLabelPrefix + 'login') }}
              </v-btn>
            </div>

            <hr/>
            <div class="lost-pas">
              <router-link :to="URLS_FACTORY.URLS_PATHS.FORGOT_PASSWORD">{{
                  $t(pageLabelPrefix + 'forgot_password')
                }}
              </router-link>
            </div>
          </v-form>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<style lang="less" scoped>
.lost-pas, .log-reg {
  margin-bottom: 100px;
  text-align: center;
  color: @font-color;
  font-size: 20px;

  a {
    text-decoration: none;
    color: @primary-color;
    font-size: 15px;
    font-weight: 400;
  }
}

//bottone login
.big-green {
  width: 255px;
}

.otp-code {
  .inpt-gen {
    margin-bottom: 20px;
  }
}

.log-reg {
  margin-top: 20px;
}

.num-call {
  text-align: center;
  display: block;
  margin-bottom: 20px;
  color: @font-color;
  font-size: 20px;
}

.main-log {
  .btn-log {
    width: 100%;
  }
}

@media @mobile {
  .lost-pas, .log-reg {
    margin-bottom: 40px;
  }
}
</style>
